module.exports = __webpack_public_path__ + "static/productivitytrap-b28521443e5d10806a989c82465ff14f.png";